import { render, staticRenderFns } from "./k-async.vue?vue&type=template&id=6d3c640b&scoped=true&"
import script from "./k-async.vue?vue&type=script&lang=ts&"
export * from "./k-async.vue?vue&type=script&lang=ts&"
import style0 from "./k-async.vue?vue&type=style&index=0&id=6d3c640b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c640b",
  null
  
)

export default component.exports